import React from "react";
import { CSVLink } from "react-csv";
import CustomText from "components/typography/CustomText";

const ExportReactCSV = ({ csvHeaders, csvData, fileName }) => (
  <CSVLink headers={csvHeaders} data={csvData} filename={fileName}>
    <CustomText className="cursor-pointer" color="secondary" bold>
      EXPORT LIST
    </CustomText>
  </CSVLink>
);

export default ExportReactCSV;
